import React, { useState, useEffect } from 'react';
import { Line } from "react-chartjs-2";
import numeral from "numeral";

const options = {
    legend: { display: false, },
    elements: {
        point: {
            radius: 0,
        },
    },
    maintainAspectRatio: false,
    tooltips: {
        mode: "index",
        intersect: false,
        callbacks: {
            label: function (tooltipItem, data) {
                return numeral(tooltipItem.value).format("+0,0");
            },
        },
    },
    scales: {
        xAxes: [
            {
                type: "time",
                time: {
                    format: "MM/DD/YY",
                    tooltipFormat: "ll",
                },
            },
        ],
        yAxes: [
            {
                gridLines: {
                    display: false,
                },

                ticks: {

                    callback: function (value, index, values) {
                        return numeral(value).format("0a");
                    },
                },
            },
        ]
    }
}

const buildChartData = (data, casesType = 'cases') => {
    const chartData = [];
    let lastDataPoint;

    // default cases but can get deaths and recovery
    for (let date in data.cases) {
        if (lastDataPoint) {
            const newDataPoint = {
                x: date,
                y: data[casesType][date] - lastDataPoint,
                // working with cases (nit death or recovery)
                // to get the new cases subtracct yesterday's from today
            };
            chartData.push(newDataPoint);
        }
        lastDataPoint = data[casesType][date];
    }
    return chartData;
};

function LineGraph({ casesType }) {

    const [data, setData] = useState({});

    useEffect(() => {
        const fetchData = async () => {

            await fetch("https://disease.sh/v3/covid-19/historical/all?lastdays=120")
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    // info render
                    // console.log(data);
                    // default --> cases [also death and recovery canbe passed as  a parameter like buildcahrtaata(data, 'recovered')]
                    let chartData = buildChartData(data, casesType);
                    setData(chartData);
                });
        };
        fetchData();
    }, [casesType]);


    return (
        <div>
            {/* Line function from Chart JS need data and option */}

            {/*  Link for getting the last 120 days of data */}
            {/* https://disease.sh/v3/covid-19/historical/all?lastdays=120 */}

            {/* data has dates and cases, deaths, recovery number sin JSON */}

            {data?.length > 0 && (
                < Line
                    data={{
                        // key is chart's data -- value is our state's data
                        datasets: [{
                            data: data,
                            backgroundColor: "rgba(204, 16, 52, 0.5",
                            borderColor: "#CC1034",

                        }]
                    }}
                    options={options}
                />

            )}

        </div>
    );
}

export default LineGraph;
